"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Copy = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Copy"));

// Generated by script, don't edit it please.
var Copy = (0, _createSvgIcon["default"])({
  as: _Copy["default"],
  ariaLabel: 'copy',
  category: 'action',
  displayName: 'Copy'
});
var _default = Copy;
exports["default"] = _default;
module.exports = exports.default;